import { showWarningNotify } from "../../utils/Notiffication";
import { mainFetch } from "../mainFetch";

const SERVICE_URL = '/shipment/posting'

const fetchService = async ({ url, ...params }) =>
    await mainFetch({ url: SERVICE_URL + url, ...params })
        .catch(e => { console.log(e); throw (e) });


export default class PostingsApi {

    // static async addOrdersToShipment({ data = { orderId: undefined, shipmentId: undefined, shops: undefined, date: undefined, postings: undefined, }, ...params }) {
    //     return await fetchService({ url: '/addtoshipment', method: 'POST', data, ...params })
    // }

    static async updatePostingsStatus({ data = { shipmentId: undefined, shop: undefined, market: undefined }, ...params }) {
        return await fetchService({ url: '/updatestatuses', method: 'POST', data, ...params })
    }

    static async loadStickers({ data = { shipmentId: undefined }, ...params }) {
        showWarningNotify('Загрузка этикеток началась');
        return await fetchService({ url: '/loadstickers', method: 'POST', data, ...params })
    }

    static async loadMetaData({ data = { shipmentId: undefined }, ...params }) {
        return await fetchService({ url: '/loadmetadata', method: 'POST', data, ...params })
    }

    static async sendMetadata({ data = { postingNumber: undefined, productId: undefined }, ...params }) {
        return await fetchService({ url: '/sendmetadata', method: 'POST', data, ...params })
    }

    static async removeMetadata({ data = { postingNumber: undefined, productId: undefined }, ...params }) {
        return await fetchService({ url: '/removemetadata', method: 'POST', data, ...params })
    }

    static async addOverage({ data = { postingNumber: undefined, productId: undefined, overageQuantity: undefined }, ...params }) {
        return await fetchService({ url: '/addoverage', method: 'POST', data, ...params })
    }




    static async changePosting({ data = { postingNumber: undefined, field: undefined, value: undefined }, ...params }) {
        return await fetchService({ url: '/changeposting', method: 'PATCH', data, ...params })
    }

    static async changePostings({ data = { postingNumbers: undefined, field: undefined, value: undefined }, ...params }) {
        return await fetchService({ url: '/changepostings', method: 'PATCH', data, ...params })
    }

    static async changeHistoryPosting({ data = { postingNumber: undefined, action: undefined, historyElementId: undefined, value: undefined }, ...params }) {
        return await fetchService({ url: '/changehistoryposting', method: 'PATCH', data, ...params })
    }

    static async changeProductInPosting({ data = { postingNumber: undefined, productId: undefined, field: undefined, value: undefined, file: undefined, action: undefined }, ...params }) {
        return await fetchService({ url: '/changeproduct', method: 'PATCH', data, notify: { msg: 'Изменения сохранены' }, ...params })
    }

    // static async changePostingCheckup({ data = { postingNumber: undefined, checkupId: undefined, penalty: undefined }, ...params }) {
    //     return await fetchService({ url: '/changecheckup', method: 'PATCH', data, ...params })
    // }

    static async syncProviderData({ data = { shipmentId: undefined }, ...params }) {
        return await fetchService({ url: '/syncproviderdata', method: 'PATCH', data, ...params })
    }

    // static async saveOrderInfo({ data = { shipmentId: undefined, file: undefined }, ...params }) {
    //     return await fetchService({ url: '/saveorderinfo', method: 'POST', data, ...params })
    // }




    static async getTabsCount({ data = { filterAlters: undefined, tab: undefined, pageName: undefined, market: undefined, shop: undefined, shipmentIds: undefined, skladName: undefined, providerId: undefined, search: undefined, filters: undefined, period: undefined, limit: undefined, page: undefined, sortType: undefined }, ...params }) {
        return await fetchService({ url: '/gettabscount', method: 'POST', data, notify: { success: false }, ...params })
    }

    static async getPosting({ data = { postingNumber: undefined }, ...params }) {
        return await fetchService({ url: '/getposting', method: 'POST', data, notify: { success: false }, ...params })
    }

    static async getPostingsByShipmentIds({ data = { tab: undefined, market: undefined, shop: undefined, shipmentIds: undefined, skladName: undefined, shipmentFilter: undefined, providerId: undefined, search: undefined, filters: undefined, limit: undefined, page: undefined, sortType: undefined }, ...params }) {
        return await fetchService({ url: '/getpostings', method: 'POST', data, notify: { success: false }, ...params })
    }

    static async getAllPostings({ data = { tab: undefined, market: undefined, shop: undefined, shipmentIds: undefined, skladName: undefined, shipmentFilter: undefined, providerId: undefined, search: undefined, filters: undefined, period: undefined, saleSchema: undefined, limit: undefined, page: undefined, sortType: undefined }, ...params }) {
        return await fetchService({ url: '/getallpostings', method: 'POST', data, notify: { success: false }, ...params })
    }

    static async getWbExpress({ data = { tab: undefined, market: undefined, shop: undefined, shipmentIds: undefined, skladName: undefined, shipmentFilter: undefined, providerId: undefined, search: undefined, filters: undefined, period: undefined, saleSchema: undefined, limit: undefined, page: undefined, sortType: undefined }, ...params }) {
        return await fetchService({ url: '/getwbexpress', method: 'POST', data, notify: { success: false }, ...params })
    }

    static async getDokupPostings({ data = { tab: undefined, market: undefined, shop: undefined, shipmentIds: undefined, skladName: undefined, providerId: undefined, filterAlters: undefined, search: undefined, filters: undefined, period: undefined, limit: undefined, page: undefined, sortType: undefined }, ...params }) {
        return await fetchService({ url: '/getdokup', method: 'POST', data, notify: { success: false }, ...params })
    }

    static async getDiscrepanciesPostings({ data = { tab: undefined, market: undefined, shop: undefined, shipmentIds: undefined, skladName: undefined, providerId: undefined, search: undefined, filters: undefined, period: undefined, limit: undefined, page: undefined, sortType: undefined }, ...params }) {
        return await fetchService({ url: '/getdiscrepancies', method: 'POST', data, notify: { success: false }, ...params })
    }

    static async getPackagingPostings({ data = { tab: undefined, users: undefined, market: undefined, shop: undefined, shipmentIds: undefined, skladName: undefined, providerId: undefined, search: undefined, filters: undefined, period: undefined, limit: undefined, page: undefined, sortType: undefined }, ...params }) {
        return await fetchService({ url: '/getpackaging', method: 'POST', data, notify: { success: false }, ...params })
    }

    static async getOverages({ data = { tab: undefined, market: undefined, shop: undefined, shipmentIds: undefined, skladName: undefined, providerId: undefined, search: undefined, filters: undefined, period: undefined, limit: undefined, page: undefined, sortType: undefined }, ...params }) {
        return await fetchService({ url: '/getoverages', method: 'POST', data, notify: { success: false }, ...params })
    }

    static async getCheckCamera({ data = { tab: undefined, market: undefined, shop: undefined, shipmentIds: undefined, skladName: undefined, providerId: undefined, search: undefined, filters: undefined, period: undefined, limit: undefined, page: undefined, sortType: undefined }, ...params }) {
        return await fetchService({ url: '/getcheckcamera', method: 'POST', data, notify: { success: false }, ...params })
    }

    static async getCheckReviews({ data = { tab: undefined, market: undefined, shop: undefined, shipmentIds: undefined, skladName: undefined, providerId: undefined, search: undefined, filters: undefined, period: undefined, limit: undefined, page: undefined, sortType: undefined }, ...params }) {
        return await fetchService({ url: '/getcheckreviews', method: 'POST', data, notify: { success: false }, ...params })
    }

    static async getCheckShipment({ data = { tab: undefined, market: undefined, shop: undefined, shipmentIds: undefined, skladName: undefined, providerId: undefined, search: undefined, filters: undefined, period: undefined, limit: undefined, page: undefined, sortType: undefined }, ...params }) {
        return await fetchService({ url: '/getcheckshipment', method: 'POST', data, notify: { success: false }, ...params })
    }

    static async getCheckVariance({ data = { tab: undefined, market: undefined, shop: undefined, shipmentIds: undefined, skladName: undefined, providerId: undefined, search: undefined, filters: undefined, period: undefined, limit: undefined, page: undefined, sortType: undefined }, ...params }) {
        return await fetchService({ url: '/getcheckvariance', method: 'POST', data, notify: { success: false }, ...params })
    }

    static async getCheckBuh({ data = { tab: undefined, market: undefined, shop: undefined, skladName: undefined, providerId: undefined, search: undefined, filters: undefined, period: undefined, limit: undefined, page: undefined, sortType: undefined }, ...params }) {
        return await fetchService({ url: '/getcheckbuh', method: 'POST', data, notify: { success: false }, ...params })
    }




    // static async postingsStatistic({ data = { period: undefined, sortType: undefined, providerId: undefined, saleSchema: undefined, filters: undefined }, ...params }) {
    //     return await fetchService({ url: '/postingsstatistic', method: 'POST', data, notify: { success: false }, ...params })
    // }




    static async excelProductsInPostings({ data = { tab: undefined, market: undefined, shop: undefined, skladName: undefined, shipmentIds: undefined, providerId: undefined, search: undefined, filters: undefined, period: undefined }, ...params }) {
        return await fetchService({ url: '/excelproductsinposting', method: 'POST', data, options: { download: true }, ...params })
    }

    static async excelDiscrepancies({ data = { tab: undefined, market: undefined, shop: undefined, skladName: undefined, shipmentIds: undefined, providerId: undefined, search: undefined, filters: undefined, period: undefined }, ...params }) {
        return await fetchService({ url: '/exceldiscrepancies', method: 'POST', data, options: { download: true }, ...params })
    }

    static async excelWorkers({ data = { users: undefined, period: undefined }, ...params }) {
        return await fetchService({ url: '/excelworkers', method: 'POST', data, options: { download: true }, ...params })
    }

    static async excelPackagersStatistic({ data = { user: undefined, periodWorker: undefined }, ...params }) {
        return await fetchService({ url: '/excelworkerdetail', method: 'POST', data, options: { download: true }, ...params })
    }




    // static async asynchandleOrders({ data = { shop: undefined, orderedItems: undefined, skladName: undefined }, ...params }) {
    //     return await fetchService({ url: '/handleorders', method: 'POST', data, ...params })
    // }

    static async getSumBySumDesc({ data = { postingNumber: undefined, checkupId: undefined, sumDesc: undefined }, ...params }) {
        return await fetchService({ url: '/getsumbysumdesc', method: 'POST', data, ...params })
    }

    static async downloadPrivateFile({ data = { postingNumber: undefined, productId: undefined, field: undefined }, ...params }) {
        return await fetchService({ url: '/downloadprivatefile', method: 'POST', data, options: { download: true }, ...params })
    }





}